import type { RequiredGeneric } from '@pba/react-utils';
import {
  Col,
  type FileUploadDone,
  Form,
  FormSection,
  Icon,
  ImageDraggerWithCrop,
  type LocalImageUpload,
  RichTextInput,
  Row,
  type UploadChangeParam,
  type UploadFile,
  prepareLocalImageUpload,
} from 'ui';
import { loadImage } from 'common/utils';

export type ExtendedDescriptionImageFormContentValues = {
  heroImage?: [FileUploadDone];
  htmlDescription?: string;
  textDescription?: string;
};

// TODO: Refactor this layout to use CSS Grid and minmax() with 1fr/2fr - so the rich text input stretches naturally instead of relying on fixed pixel heights.
const RICH_TEXT_INPUT_MAX_HEIGHT = 281;
const RICH_TEXT_INPUT_MIN_HEIGHT = 121;

const DescriptionImageFormContent = <T extends ExtendedDescriptionImageFormContentValues = never>(
  _: RequiredGeneric<T>,
) => (
  <FormSection title={{ children: 'Description and image', icon: <Icon icon="information-line" /> }}>
    <Row gutter="xs" wrap={false}>
      <Col flex="auto">
        <RichTextInput
          html={{
            label: 'Description',
            maxHeight: RICH_TEXT_INPUT_MAX_HEIGHT,
            minHeight: RICH_TEXT_INPUT_MIN_HEIGHT,
            name: 'htmlDescription',
          }}
          text={{ name: 'textDescription' }}
        />
      </Col>
      <Col flex="none">
        <Form.Item<ExtendedDescriptionImageFormContentValues>
          getValueFromEvent={({ fileList }: UploadChangeParam<UploadFile<LocalImageUpload>>) => fileList}
          label="Hero image"
          name="heroImage"
          rules={[{ required: true }]}
          valuePropName="fileList"
        >
          <ImageDraggerWithCrop
            dragger={{
              loadImage,
              shape: 'rectangle-stretch',
              uploadFile: prepareLocalImageUpload,
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  </FormSection>
);

export default DescriptionImageFormContent;
